export function baseAnimations() {
  return {
    enter: {
      opacity: 1,
      scale: 1,
      transition: { duration: 250, delay: 250 }
    },
    exit: { opacity: 0, scale: 0.95 }
  };
}
